import {NgModule} from '@angular/core';

import {DbModalService} from './modal';
import {DbModalBackdropComponent} from './modal-backdrop';
import {DbModalWindowComponent} from './modal-window';
import {TransitionHandler} from "./transition-handler";

export {DbModalService} from './modal';
export {DbModalConfig, DbModalOptions} from './modal-config';
export {DbModalRef, DbActiveModal} from './modal-ref';

@NgModule({
  declarations: [DbModalBackdropComponent, DbModalWindowComponent],
  // entryComponents: [DbModalBackdropComponent, DbModalWindowComponent],
  providers: [DbModalService, TransitionHandler]
})
export class DbModalModule {
}
